export default __webpack_public_path__ + "static/media/payroll-3.dc70fba1.svg";